import React, { useState } from 'react';
import s from './App.module.css';
import Journey from './screens/Journey';
import MobilePortal from './screens/MobilePortal';
import EarlyPay from './screens/EarlyPay';

const TABS = [
  { id: 'journey', icon: 'ti-route', label: 'Supplier journey' },
  { id: 'portal', icon: 'ti-device-mobile', label: 'Mobile portal' },
  { id: 'earlypay', icon: 'ti-bolt', label: 'Early payment' },
];

export default function App() {
  const [active, setActive] = useState('journey');

  return (
    <div className={s.app}>
      <div className={s.tabs}>
        {TABS.map(t => (
          <button
            key={t.id}
            className={`${s.tab} ${active === t.id ? s.tabOn : ''}`}
            onClick={() => setActive(t.id)}
          >
            <i className={`ti ${t.icon}`} />
            {t.label}
          </button>
        ))}
      </div>

      <div className={s.pane}>
        {active === 'journey' && <Journey />}
        {active === 'portal' && <MobilePortal />}
        {active === 'earlypay' && <EarlyPay />}
      </div>
    </div>
  );
}
